export default __webpack_public_path__ + "static/media/wozaif.f4df0661.jpg";